import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui';

import { ComparisonCard } from './components/ComparisonCard';

const changeOrgFeatures = [
	'Easy petition creation with AI support',
	'Built-in supporter updates and communication tools',
	'Campaign analytics and actionable insights',
	'Mobile-optimized signing and sharing',
	'Direct decision-maker tagging',
	'Export supporter lists',
] as const;

const otherPlatformFeatures = [
	'Manual petition setup',
	'Limited or external communication tools',
	'Basic or unclear performance metrics',
	'Inconsistent mobile experience',
	'Indirect or no access to decision makers',
	'Limited or paid access to supporter data',
] as const;

export function NoFees(): JSX.Element {
	return (
		<div className="bg-white py-16 md:py-24">
			<div className="container">
				<div className="mb-18 flex flex-col items-center gap-4 text-center">
					<Text as="h2" variant="heading" className="text-size-heading">
						No fees. Just change.
					</Text>
					<Text as="p" variant="body" size="large" className="text-size-body-xl max-w-xs md:max-w-xl">
						Everything you need to run a successful campaign — without the cost.
					</Text>
				</div>
				<div className="relative mx-auto flex max-w-4xl flex-col gap-6 md:flex-row md:items-end">
					<div className="relative z-10 md:w-[55%] md:min-w-0 md:shrink-0 md:-translate-y-1">
						<ComparisonCard title="Change" isChangeOrg features={changeOrgFeatures} />
					</div>
					<div className="relative z-0 md:absolute md:right-0 md:bottom-0 md:w-[55%] md:min-w-0">
						<ComparisonCard title="Other Platforms" features={otherPlatformFeatures} />
					</div>
				</div>
			</div>
		</div>
	);
}
